module.exports = __webpack_public_path__ + "img/ai_teacher_Tina.0d9c8a59.png";